// router/index.js
import VueRouter from "vue-router";
import Layout from "@/layout/index.vue";
import Login from "@/views/login";
import Privacy from "@/views/privacy";
import Vue from "vue";
import store from "../store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: { title: "后台管理登录", showMenu: false },
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: Privacy,
    meta: { title: "隐私政策", showMenu: false },
  },
  {
    path: "/",
    name: "Index",
    component: Layout,
    meta: { title: "小程序管理", showMenu: true },
    redirect: "/banner",
    children: [
      {
        path: "/banner",
        name: "Banner",
        meta: { title: "Banner管理", showMenu: true },
        component: () => import("@/views/banner/index.vue"),
      },
      {
        path: "/celebrity",
        name: "Celebrity",
        meta: { title: "名家管理", showMenu: true },
        component: () => import("@/views/celebrity/index.vue"),
      },
      {
        path: "/subject",
        name: "Subject",
        meta: { title: "专题管理", showMenu: true },
        component: () => import("@/views/subject/index.vue"),
      },
      {
        path: "/activity",
        name: "Activity",
        meta: { title: "活动管理", showMenu: true },
        component: () => import("@/views/activity/index.vue"),
      },
      {
        path: "/show",
        name: "Show",
        meta: { title: "展览管理", showMenu: true },
        component: () => import("@/views/show/index.vue"),
      },
      {
        path: "/city",
        name: "City",
        meta: { title: "城市管理", showMenu: true },
        component: () => import("@/views/city/index.vue"),
      },
      {
        path: "/visit",
        name: "Visit",
        meta: { title: "参观管理", showMenu: true },
        component: () => import("@/views/visit/index.vue"),
      },
    ],
  },
  {
    path: "/data",
    name: "Data",
    component: Layout,
    redirect: "/creation",
    meta: { title: "数据管理", showMenu: true },
    children: [
      {
        path: "/parts",
        name: "Parts",
        meta: { title: "部分管理", showMenu: true },
        component: () => import("@/views/parts/index.vue"),
      },
      {
        path: "/category",
        name: "Category",
        meta: { title: "文章分类管理", showMenu: true },
        component: () => import("@/views/research/category.vue"),
      },
      {
        path: "/creation",
        name: "Creation",
        meta: { title: "藏品管理", showMenu: true },
        component: () => import("@/views/creation/index.vue"),
      },
      {
        path: "/research",
        name: "Research",
        meta: { title: "研究管理", showMenu: true },
        component: () => import("@/views/research/index.vue"),
      },
    ],
  },
  {
    path: "/system",
    name: "System",
    component: Layout,
    redirect: "/users",
    meta: { title: "系统管理", showMenu: true },
    children: [
      {
        path: "/users",
        name: "Users",
        meta: { title: "账号分配", showMenu: true },
        component: () => import("@/views/system/users.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

const whiteList = ["/login", "/privacy"];
router.beforeEach(async (to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  // 白名单中的路由直接放行
  if (whiteList.includes(to.path)) {
    next();
    return;
  }
  if (store.getters.isLogin) {
    if (to.path === "/login") {
      // 已登录且要访问登录页，则跳转到首页
      next({ path: "/" });
    } else {
      next();
    }
  } else {
    next(`/login?redirect=${to.path}`);
  }
});

export default router;
